import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import { Popover } from "ui-components/popover/popover";
import TerminalDetails from "ui-components/terminal-details/terminalDetails";

const columnHelper = createColumnHelper<any>();

export const getDriversColumns = () => [
  columnHelper.accessor("driverId", {
    id: "driverId",
    header: "Driver ID",
    cell: (cellProps) => (
      <div>{cellProps.getValue()}</div>
    ),
    size: 120,
    minSize: 120,
  }),
  columnHelper.accessor("firstName", {
    id: "firstName",
    header: "Name",
    cell: (cellProps) => (
      <div>{cellProps.getValue()} {cellProps.row.original.lastName}</div>
    ),
    size: 150,
    minSize: 150,
  }),
  columnHelper.accessor("commercialDriverLicense.licenseClass", {
    id: "commercialDriverLicense.licenseClass",
    header: () => (
      <>
        CDL Class  <Popover values={<div className="drivers-sidebar__tooltip">Indicates the type of vehicle the driver is licensed to operate. Class A: large trucks, Class B: buses, Class C: smaller vehicles.</div>} />
      </>
    ),
    cell: (cellProps) => {
      return cellProps.getValue()?.length > 0 ?
        <div className="drivers-list__cdl">{cellProps.getValue()}</div> : <></>
    },
    size: 120,
    minSize: 120,
  }),
  columnHelper.accessor("domicileTerminalNumber", {
    id: "domicileTerminalNumber",
    header: () => (
      <>
        Terminal  <Popover values={<div className="drivers-sidebar__tooltip">The driver’s assigned work location or dispatch point.</div>} />
      </>
    ),
    cell: (cellProps) => {
      return <TerminalDetails terminalNumber={cellProps.getValue()?.toString() || ""} />
    },
    size: 180,
    minSize: 180,
  }),
  columnHelper.accessor("status", {
    id: "status",
    header: "Status",
    cell: (cellProps) => (
      cellProps.getValue() === 'active' ?
        <div className="drivers-list__status drivers-list__status__active">{cellProps.getValue()}</div>
        : <div className="drivers-list__status drivers-list__status__inactive">{cellProps.getValue()}</div>
    ),
    size: 120,
    minSize: 120,
  }),
];